import Alpine from 'alpinejs'

const planManager = () => ({
  existingPlansCount: 0,
  defaultShippingFeeItems: [],
  newPlans: [],
  removedPlanIds: [],

  initWithData(jsonString) {
    const data = typeof jsonString === 'string' ? JSON.parse(jsonString) : jsonString
    this.existingPlansCount = data.existingPlansCount || 0
    this.defaultShippingFeeItems = data.defaultShippingFeeItems || []
  },

  addPlan() {
    this.newPlans.push({
      tempId: Date.now(),
      name: '',
      description: '',
      price: null,
      special_price: null,
      convenienceStoreEnabled: false,
      convenienceStoreShippingFee: 0,
      shippingFeeItems: this.defaultShippingFeeItems.map((item, i) => ({
        id: Date.now().toString() + '_' + i,
        country: item.country,
        fee: item.fee
      })),
      productItems: [{ id: Date.now().toString(), productId: '', quantity: 1 }],
      imageUrl: null
    })
  },

  duplicatePlan(planData) {
    this.newPlans.push({
      tempId: Date.now(),
      name: (planData.name || '') + '(複製)',
      description: planData.description || '',
      price: planData.price,
      special_price: planData.special_price,
      convenienceStoreEnabled: !!planData.convenienceStoreEnabled,
      convenienceStoreShippingFee: planData.convenienceStoreShippingFee || 0,
      shippingFeeItems: (planData.shippingFeeItems || []).map(item => ({
        id: Date.now().toString() + Math.random().toString(36).substring(2, 11),
        country: item.country,
        fee: item.fee
      })),
      productItems: (planData.productItems || []).map(item => ({
        id: Date.now().toString() + Math.random().toString(36).substring(2, 11),
        productId: item.productId,
        quantity: item.quantity
      })),
      imageUrl: null
    })
  },

  removeNewPlan(tempId) {
    this.newPlans = this.newPlans.filter(p => p.tempId !== tempId)
  },

  markExistingPlanForRemoval(planId) {
    this.removedPlanIds.push(planId)
  },

  isExistingPlanRemoved(planId) {
    return this.removedPlanIds.includes(planId)
  }
})

Alpine.data('planManager', planManager)
export default planManager
